import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from "react-router-dom";
import Datatable from '../../ExtraComponents/ReusableTable2';
import { getAllQuotes, deleteQuote, convertQuote, createQuote } from "../../ReduxStore/Slice/Quote/CreateQuoteSlice";
import { useDispatch } from "react-redux";
import { PenLine, Trash2 } from 'lucide-react';
import { DateConvert, DateConvertWithTime ,cleanHtmlEntities } from '../../Utils/CommonFun';
import Swal from "sweetalert2";
import axios from "axios";
import ReactPaginate from "react-paginate";

import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers-pro/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import dayjs from "dayjs"
import { DatePicker, Space, theme } from 'antd';
import * as Config from "../../Utils/Config";


const AllQuotes = () => {

  const { state } = useLocation();

  const [isStateReady, setIsStateReady] = useState(false);

  const dispatch = useDispatch();
  const nevigate = useNavigate();
  const agent_id = JSON.parse(localStorage.getItem("agent_id"));
  const userDetails = JSON.parse(localStorage.getItem("details"));
  const [allQuoteData, setAllQuoteData] = useState([]);
  const [isLoading, setLoading] = useState(false);


  const [pageSize, setPageSize] = useState(50);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [InputValue, setInputValue] = useState('');

  const [activeTab, setActiveTab] = useState("");
  const [quoteTiles, setQuoteTiles] = useState("");
  const [range, setRange] = useState(null);

  useEffect(() => {
    if (state?.activeTab && state?.quoteTiles) {
      setActiveTab(state.activeTab);
      setQuoteTiles(state.quoteTiles);

      if (Array.isArray(state.range)) {
        setRange([
          dayjs(state.range[0]),
          dayjs(state.range[1])
        ]);
      }

      // 🔑 mark state ready
      setIsStateReady(true);
    }
  }, [state]);




  const handlePageChange = (page) => {
    setCurrentPage(page.selected + 1);
  };


  const handlePageSizeChange = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setPageSize(newSize);
    setCurrentPage(1);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [InputValue])



  useEffect(() => {

    if (state?.activeTab === undefined && state?.quoteTiles === undefined) {
      AllQuote();
    } else {
      if (!isStateReady) return;
      AllQuote();
    }

  }, [currentPage, pageSize, InputValue, activeTab, range, quoteTiles]);

  const handleTabChange = (event) => {
    setActiveTab(event.target.value);
  };

  const handleQuoteTiles = (event) => {
    setQuoteTiles(event.target.value)
  }

  const AllQuote = async () => {
    let req = { agent_id: agent_id, page: currentPage, limit: pageSize, search: InputValue, filter: activeTab, quoteTiles: quoteTiles };

    if (activeTab === "custom-date" && Array.isArray(range) &&
      range[0] &&
      range[1]) {
      req = {
        ...req,
        startDate: dayjs(range[0])?.format("YYYY-MM-DD"),
        endDate: dayjs(range[1])?.format("YYYY-MM-DD")
      };
    }

    await dispatch(getAllQuotes(req)).unwrap()
      .then((response) => {
        if (response.status) {
          setAllQuoteData(response.data);
          setTotalRecords(response?.pagination?.total)

        } else {
          setAllQuoteData([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching charge basis data:", error);
      });
  };


  const handleStopReminder = async (row) => {

    let stop_remainder_status = row.stop_remainder_status;
    let msg = "Stop";
    if (Number(row.stop_remainder_status) == 1) {
      stop_remainder_status = '0';
      msg = "Start";
    } else {
      stop_remainder_status = '1';
      msg = "Stop";
    }

    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${msg} reminder for this contract!`,
      icon: "warning",
      showCancelButton: true,

      confirmButtonText: msg + " Reminder",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const req = { id: row.id, stop_remainder_status: stop_remainder_status, step: 5 };

        console.log("req", req);
        await dispatch(createQuote(req))
          .unwrap()
          .then((response) => {
            if (response.status) {
              Swal.fire({
                title: "Success!",
                text: `Reminder ${msg} successfully.`,
                showConfirmButton: true,
                confirmButtonText: "Ok",
                icon: "success",

                timer: 3000,
              });
              AllQuote();
            } else {
              Swal.fire("Error!", "Something went wrong.", "error");
            }
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        return;
      }
    });

  }



  const columns = [
    {
      name: "Subject",
      selector: (row) => row?.subject == null || row?.subject == "" ? "-" : row?.subject,
      sortable: true,
    },
    {
      name: "Client",
      selector: (row) => cleanHtmlEntities(row?.Client.client_name),
      sortable: true,
    },
    // {
    //   name: "Yearly Cost",
    //   selector: (row) => row?.yearly_cost,
    //   sortable: true,
    // },
     {
                name: "Created On",
                selector: row => row.createdAt,
                cell: row => DateConvertWithTime(row.createdAt),
                sortable: true,
                sortFunction: (a, b) =>
                  new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
              },
    // {
    //   name: "Status",
    //   selector: (row) => ({
    //     0: "In Progress",
    //     1: "Quote Accepted",
    //     2: " Quote Rejected",
    //     3: "Quote Sent",
    //   }[Number(row?.status)] || "-"),
    //   sortable: true,
    // },
    {
      name: "Status",
      selector: (row) => {
        const status = Number(row?.status);

        if (status === 0) {
          // Yaha apni extra condition lagao
          if (Number(row?.higher_discount_status) === 0 && Number(row?.request_higher_discount_ongoing) === 1) {
            return "Requested Higher Discount";
          }
          else if (Number(row?.higher_discount_status_oneoff) === 0 && Number(row?.request_higher_discount_oneoff) === 1) {
            return "Requested Higher Discount";
          }
          else if (Number(row?.higher_discount_status) === 1 || Number(row?.higher_discount_status_oneoff) === 1) {
            return "Discount Approved";
          }
          else if (Number(row?.higher_discount_status) === 2 || Number(row?.higher_discount_status_oneoff) === 2) {
            return "Discount Rejected";
          }
           else {
            return "In Progress";
          }
        }

        return {
          1: "Quote Accepted",
          2: "Quote Rejected",
          3: "Quote Sent",
        }[status] || "-";
      },
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <div className="d-block w-100 text-end" style={{ position: "absolute", left: "-35px", top: "5px" }}>
          {Number(row.status) != 0 && row.Contracts.length === 0
            ?
            <button className="btn btn-sm-pink" onClick={(e) => handleConvert(e, row)}>
              <i className=" ri-repeat-line pe-1" />
              Convert
            </button>
            : "  "
          }
          <button className="btn fs-4 py-0 px-1" onClick={() => handleEdit(row)}>
            <i className=" ri-edit-line" />
          </button>
          <button className="btn fs-4 py-0 px-1" onClick={() => handleDelete(row)}>
            <i className="bx bx-trash" />
          </button>
          {/* Resend Contract Button with appropriate icon */}
          {Number(row?.status) !== 0 ?
            <>
              <button
                className="btn fs-4 py-0 px-1"
                onClick={() => handleStopReminder(row)}
                title={Number(row.stop_remainder_status) === 1 ? "Start Reminder" : "Stop Reminder"}
              >
                {/* <i className="ri-timer-line" /> */}
                <i
                  className={`ri-timer-line ${Number(row.stop_remainder_status) === 1 ? "text-danger" : "text-success"
                    }`}
                />
              </button>
            </> :
            ""
          }
        </div>
      ),
      sortable: true,
      width: "220px",
    }
  ];

  const handleConvert = async (e, row) => {

    let req = { row: row };
    await dispatch(convertQuote(req)).unwrap()
      .then((res) => {
        if (res.status) {

          sessionStorage.setItem("contract_id", res.contract_id);
          nevigate("/admin/contracts/create-contract", { state: { row: { id: res.contract_id, step: 3 } } });
        }
        else {

        }
      })
      .catch((err) => {

      });


  };


  const handleEdit = (row) => {
    nevigate("/admin/quote/create-quote", { state: { row: row } });
  };

  const handleDelete = async (row) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this quote!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel'
    }).then(async (result) => {
      if (result.isConfirmed) {
        const req = { id: row.id , user_id: userDetails?.id };
        await dispatch(deleteQuote(req)).unwrap()
          .then((response) => {
            if (response.status) {
              Swal.fire({
                title: 'Deleted!',
                text: 'Your quote has been deleted.',
                icon: 'success',
                showConfirmButton: false,
                timer: 2000
              }).then(() => {
                AllQuote();
              })
            } else {
              Swal.fire('Error!', 'Something went wrong.', 'error');
            }
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your quote is safe :)', 'error')
      }
    });


  };

  useEffect(() => {
    if (isLoading) {
      Swal.fire({
        title: "",
        html: '<div style="height:250px;"><div class="loader" style="margin:0px auto;"></div><p class="text-white mt-3">Please Wait...</p></div>',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        background: "transparent",
        backdrop: "rgba(229, 233, 236, 0.2)",

        customClass: {
          popup: "no-shadow",
        },
      });
    } else {
      Swal.close();
    }
  }, [isLoading]);

  const handleExport = async () => {

    let totalData = allQuoteData;

    let req = { agent_id: agent_id, page: 1, limit: 100000, search: "", filter: activeTab, quoteTiles: quoteTiles };

    if (activeTab === "custom-date" && Array.isArray(range) &&
      range[0] &&
      range[1]) {
      req = {
        ...req,
        startDate: dayjs(range[0])?.format("YYYY-MM-DD"),
        endDate: dayjs(range[1])?.format("YYYY-MM-DD")
      };
    }

    await dispatch(getAllQuotes(req))
      .unwrap()
      .then((response) => {
        if (response.status) {
          totalData = response.data
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'No Data',
            text: 'No data to export!',
          });
          return
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: 'warning',
          title: 'No Data',
          text: 'No data to export!',
        });
        return
      });

    if (totalData.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'No Data',
        text: 'No data to export!',
      });
      return
    }

    // export format
    const exportData = totalData?.map((row) => ({
      "Subject": row?.subject,
      "Client": row?.Client?.client_name,
      "Created On": DateConvertWithTime(row?.createdAt),
      "Status": Number(row?.status) === 3 ? "Quote Sent" :
        Number(row?.status) === 5 ? "Quote Reviewed" :
          Number(row?.status) === 1 ? "Quote Accepted" :
            Number(row?.status) === 2 ? "Quote Rejected" :
              "In Progress",
    }));

    downloadCSV(exportData, "Quote Details.csv");
  };
  const downloadCSV = (data, filename) => {
    const csvRows = [];

    // headers
    const headers = Object.keys(data[0]);
    csvRows.push(headers.join(","));

    // rows
    data.forEach((row) => {
      const values = headers.map((h) => `"${row[h] || ""}"`);
      csvRows.push(values.join(","));
    });

    const csvString = csvRows.join("\n");

    const blob = new Blob([csvString], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.setAttribute("href", url);
    a.setAttribute("download", filename);
    a.click();
  };

  const handleExportPDF = async () => {
    setLoading(true);
    let totalData = allQuoteData;

    let req = { agent_id: agent_id, page: 1, limit: 100000, search: "", filter: activeTab, quoteTiles: quoteTiles };

    if (
      activeTab === "custom-date" &&
      Array.isArray(range) &&
      range[0] &&
      range[1]
    ) {
      req.startDate = dayjs(range[0]).format("YYYY-MM-DD");
      req.endDate = dayjs(range[1]).format("YYYY-MM-DD");
    }

    await dispatch(getAllQuotes(req))
      .unwrap()
      .then((response) => {
        if (response.status) {
          totalData = response.data
        } else {
          setLoading(false);
          Swal.fire({
            icon: 'warning',
            title: 'No Data',
            text: 'No data to export!',
          });
          return
        }
      })
      .catch((error) => {
        setLoading(false);
        Swal.fire({
          icon: 'warning',
          title: 'No Data',
          text: 'No data to export!',
        });
        return
      });

    if (totalData.length === 0) {
      setLoading(false);
      Swal.fire({
        icon: 'warning',
        title: 'No Data',
        text: 'No data to export!',
      });
      return
    }



    // export format
    const formattedData = totalData?.map((row) => ({
      subject: row?.subject,
      client: row?.Client?.client_name,
      createdAt: DateConvertWithTime(row?.createdAt),
      status: Number(row?.status) === 3 ? "Quote Sent" :
        Number(row?.status) === 5 ? "Quote Reviewed" :
          Number(row?.status) === 1 ? "Quote Accepted" :
            Number(row?.status) === 2 ? "Quote Rejected" :
              "In Progress",
    }));

    const res = await axios.post(
      Config.base_url + "export-contract-pdf",
      { data: formattedData },
      { responseType: "blob" }
    );

    setLoading(false);

    const blob = new Blob([res.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "Quote_Details.pdf";
    a.click();
  };

 const showPagination  = pageSize !== 0 && Math.ceil(totalRecords / pageSize)
  return (
    <div>
      <div className="row mb-3">
        <div className="col">
          <h4 className="page-title">
            <Link to="/admin/quote/quotes-dashboard">
              <i className='bx bx-arrow-back text-pink'></i>
            </Link> All Quotes
          </h4>
        </div>
        <div className="col-auto align-self-center">
          {allQuoteData?.length > 0 && (
            <>
              <button className="btn-outline-pink btn me-2" onClick={handleExportPDF}>
                <i className="ri-download-2-line"></i> Export PDF
              </button>

              <button className="btn-outline-pink btn me-2"
                onClick={handleExport}
              >
                <i className="ri-download-2-line"></i>  Export CSV
              </button>
            </>
          )}
          <Link to="/admin/quote/create-quote" className="btn btn-pink" id="Dash_Date">
            <span className="ay-name" id="Day_Name">Add New Quote</span>
          </Link>
        </div>
      </div>

      <section className="section dashboard">
        <div className="row">
          <data className='col-lg-3 datatable-search'>
            <input type="text"
              className='search p-2 icon'
              placeholder='Search here'
              value={InputValue}
              onChange={(e) => setInputValue(e.target.value)}
            />
          </data>

          <div className="col-lg-3 filter-select mb-3 select_tab">
            <select
              onChange={handleTabChange}
              value={activeTab}
              className="form-select"
            >
              <option value="">All</option>
              <option value="current-month">Current Month</option>
              <option value="prev-month">Previous Month</option>
              <option value="current-quarter">Current Quarter</option>
              <option value="previous-quarter">Previous Quarter</option>
              <option value="current-calender-quarter">
                Current Calendar Year
              </option>
              <option value="prev-calender-year">Previous Calendar Year</option>
              <option value="custom-date">Custom Date</option>
            </select>
          </div>

          {activeTab === "custom-date" && (
            <div className=" d-flex gap-2  mb-3 col-lg-3 custom-datefilter">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DateRangePicker"]}>
                  <DatePicker.RangePicker
                    value={range}
                    onChange={setRange}
                    placeholder={['Start Date', 'End Date']}
                    format="DD/MM/YYYY"
                    className=""
                  />
                </DemoContainer>
              </LocalizationProvider>
            </div>
          )}

          <div className="col-lg-3 filter-select mb-3 select_tab">
            <select
              onChange={handleQuoteTiles}
              value={quoteTiles}
              className="form-select"
            >
              <option value="">All</option>
              <option value="quote-created">Quote Created</option>
              <option value="quote-sent">Quote Sent</option>
              <option value="quote-unsent">Quote Unsent</option>
              {/* <option value="quote-reviewed">Quote Reviewed</option> */}
              <option value="quote-accepted">Quote Accepted</option>
              <option value="quote-rejected">Quote Rejected</option>
            </select>
          </div>
        </div>
        <div className="table-main-div">
          <div className="quote-table">
            <Datatable
              columns={columns}
              data={allQuoteData}
              filter={false}
            />
            {  allQuoteData.length > 0 ?
              <div>
                {
                   showPagination > 1 && (
                    <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  pageCount={pageSize == 0 ? 1 : Math.ceil(totalRecords / pageSize)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={handlePageChange}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                />
                   )
                }
                

                <div className="mt-0">

                  <select 
                  // className="perpage-select" 
                  className={showPagination > 1 ? "perpage-select" : "perpage-select mt-3 mb-3"}
                  value={pageSize} 
                  onChange={handlePageSizeChange}>
                    {/* <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option> */}
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={500}>500</option>
                    <option value={0}>{"ALL"}</option>
                  </select>
                </div>
              </div> : ""}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AllQuotes;
